module.exports = __webpack_public_path__ + "img/voleyball.d3b20312.svg";